import React, { ReactNode } from "react";
import { Box, useStyleConfig, BoxProps } from "@chakra-ui/react";

interface CardProps extends BoxProps {
  variant?: string;
  children?: ReactNode;
}

function Card(props: CardProps) {
  const { variant, children, sx, boxShadow, border, borderColor, borderWidth, ...rest } = props;
  const styles = useStyleConfig("Card", { variant });
  // Explicit border/shadow props must win over theme variant __css (e.g. report detail #d3d3d3 chrome).
  const mergedCss = {
    ...styles,
    ...(boxShadow !== undefined ? { boxShadow } : {}),
    ...(border !== undefined ? { border } : {}),
    ...(borderColor !== undefined ? { borderColor } : {}),
    ...(borderWidth !== undefined ? { borderWidth } : {}),
  };
  return (
    <Box __css={mergedCss} sx={sx} data-statistics-card-surface="" {...rest}>
      {children}
    </Box>
  );
}

export default Card;

